/* eslint-disable */
import 'flickity/dist/flickity.pkgd';
import 'simplelightbox/dist/simple-lightbox.min.js';

export default {
  init() {
    // HAMBURGER
    $('.hamburger').click(function() {
      $(this).toggleClass('active');
      $('body').toggleClass('hamburger-active');
    })

    if ($('.accordeon_content').length) {
      $('.accordeon_content').hide();

      $('.accordeon_title').click(function(){
        $(this).parent().toggleClass('active').siblings().removeClass('active');
        $('.accordeon_content').slideUp();

        if(!$(this).next().is(':visible')) {
          $(this).next().slideDown();
        }
      });
    }

    $('.accordeon_content').eq(0).show();

    if ($('.gallery').length > 0) {
        var $images = $('.gallery a');
        var $imagesGrouped = $images.filter('[data-group]');
        var $imagesAlone = $images.not($imagesGrouped);
        var params = {
            // your params
            navText: ['<div class="cursor-pointer h-12 w-12 border inline-flex items-center justify-center transition-bezier transition-600 group hover:bg-gray-100"><svg class="h-3 w-3 transition-bezier transition-600 group-hover:scale-120" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M10.546 3.502a1.714 1.714 0 00-2.425 0l-7.619 7.62c-.67.669-.67 1.754 0 2.424l7.62 7.619a1.714 1.714 0 002.424-2.425l-4.693-4.693h16.433c.897 0 1.633-.688 1.708-1.566l.006-.148c0-.946-.768-1.714-1.714-1.714H5.853l4.693-4.693c.63-.63.667-1.628.11-2.302z"></path></svg></div>','<div class="cursor-pointer h-12 w-12 border ml-2 inline-flex items-center justify-center transition-bezier transition-600 group hover:bg-gray-100"><svg class="h-3 w-3 transition-bezier transition-600 group-hover:scale-120" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M13.454 3.502c.67-.67 1.755-.67 2.425 0l7.619 7.62c.67.669.67 1.754 0 2.424l-7.62 7.619a1.714 1.714 0 01-2.424-2.425l4.693-4.693H1.714a1.714 1.714 0 01-1.708-1.566L0 12.333c0-.946.768-1.714 1.714-1.714h16.433l-4.693-4.693a1.714 1.714 0 01-.11-2.302z"></path></svg></div>'],
        };

        // Handle standalone images
        $imagesAlone.each(function (index, element) {
            $(element).simpleLightbox(params);
        });

        // Handle grouped imags
        if ($imagesGrouped.length > 0) {
            // Select all groups
            var groupNames = $imagesGrouped.map(function() {
                return $(this).data('group');
            }).get();
            groupNames = $.unique(groupNames);

            // Apply on each group
            $.each(groupNames, function(key, value) {
                $imagesGrouped.filter(function () {
                    return $(this).data('group') == value;
                })
                .simpleLightbox(params);
            });
        }
    }

    // Lightbox
    // if($('.gallery').length) {
    //   $('.gallery').each(function() {
    //     $(this + 'a').simpleLightbox({
    //       navText: ['<div class="cursor-pointer h-12 w-12 border inline-flex items-center justify-center transition-bezier transition-600 group hover:bg-gray-100"><svg class="h-3 w-3 transition-bezier transition-600 group-hover:scale-120" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M10.546 3.502a1.714 1.714 0 00-2.425 0l-7.619 7.62c-.67.669-.67 1.754 0 2.424l7.62 7.619a1.714 1.714 0 002.424-2.425l-4.693-4.693h16.433c.897 0 1.633-.688 1.708-1.566l.006-.148c0-.946-.768-1.714-1.714-1.714H5.853l4.693-4.693c.63-.63.667-1.628.11-2.302z"></path></svg></div>','<div class="cursor-pointer h-12 w-12 border ml-2 inline-flex items-center justify-center transition-bezier transition-600 group hover:bg-gray-100"><svg class="h-3 w-3 transition-bezier transition-600 group-hover:scale-120" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M13.454 3.502c.67-.67 1.755-.67 2.425 0l7.619 7.62c.67.669.67 1.754 0 2.424l-7.62 7.619a1.714 1.714 0 01-2.424-2.425l4.693-4.693H1.714a1.714 1.714 0 01-1.708-1.566L0 12.333c0-.946.768-1.714 1.714-1.714h16.433l-4.693-4.693a1.714 1.714 0 01-.11-2.302z"></path></svg></div>'],
    //     });
    //   });
    // }

    // SCROLLED
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > 0) {
        $('body').addClass('scrolled');
      }
      else {
        $('body').removeClass('scrolled');
      }
    });

    // FLICKITY
    if($('.sliderblur').length) {
      var $carouselblur = $('.sliderblur').flickity({
        cellAlign: 'left',
        contain: true,
        draggable: true,
        wrapAround: false,
        prevNextButtons: false,
        pageDots: false,
        pauseAutoPlayOnHover: false,
      });

      // Flickity instance
      var flktyblur = $carouselblur.data('flickity');

      // elements
      var $cellButtonGroupBlur = $('.button-group--cells-blur');
      var $cellButtons1Blur = $cellButtonGroupBlur.find('.dot-blur');

      // update selected cellButtons
      $carouselblur.on( 'select.flickity', function() {
        $cellButtons1Blur.filter('.is-selected')
        .removeClass('is-selected');
        $cellButtons1Blur.eq( flktyblur.selectedIndex )
        .addClass('is-selected');
      });

      // select cell on button click
      $cellButtonGroupBlur.on( 'click', '.dot', function() {
        var index = $(this).index();
        $carouselblur.flickity( 'select', index );
      });

      // select cell on button click
      $('.button--previous-blur').on( 'click', function() {
        $carouselblur.flickity('previous');
      });
      // next
      $('.button--next-blur').on( 'click', function() {
        $carouselblur.flickity('next');
      });

      setTimeout(function() {
        $('.sliderblur').flickity('resize');
      }, 250);
    }

    // FLICKITY
    if($('.slider').length) {
      var $carousel = $('.slider').flickity({
        cellAlign: 'left',
        contain: true,
        draggable: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        pauseAutoPlayOnHover: false,
      });

      // Flickity instance
      var flkty = $carousel.data('flickity');

      // elements
      var $cellButtonGroup = $('.button-group--cells');
      var $cellButtons1 = $cellButtonGroup.find('.dot');

      // update selected cellButtons
      $carousel.on( 'select.flickity', function() {
        $cellButtons1.filter('.is-selected')
        .removeClass('is-selected');
        $cellButtons1.eq( flkty.selectedIndex )
        .addClass('is-selected');
      });

      // select cell on button click
      $cellButtonGroup.on( 'click', '.dot', function() {
        var index = $(this).index();
        $carousel.flickity( 'select', index );
      });

      // select cell on button click
      $('.button--previous').on( 'click', function() {
        $carousel.flickity('previous');
      });
      // next
      $('.button--next').on( 'click', function() {
        $carousel.flickity('next');
      });

      var carouselStatus = document.querySelector('.carousel-status');

      setTimeout(function() {
        $('.slider').flickity('resize');
      }, 250);
    }

    function updateStatus() {
      if($('.slider').length) {
        var slideNumber = flkty.selectedIndex + 1;
        carouselStatus.innerHTML = '<span class="text-16xl">0' + slideNumber + '</span> / 0' + flkty.slides.length;
      }
    }

    updateStatus();
    if($('.slider').length) {
      flkty.on( 'select', updateStatus );
    }

    // VIDEO
    $('video').click(function(){
      this.paused ? this.play() : this.pause();
    });

    $('video').click(function() {
      $('.video').toggleClass( 'paused' );
    });

    // HAMBURGER
    $('.mobile-nav .menu-mobile-container ul li.menu-item-has-children').click(function() {
      if ($(this).hasClass('active')) {
        console.log('had al active');
        $(this).removeClass('active');
      } else {
        console.log('had geen active');
        $('.mobile-nav .menu-mobile-container ul li.menu-item-has-children').removeClass('active');
        $(this).addClass('active');
      }
    });

    // New For Kobus
    // FLICKITY
    $('.slider-characteristic').each(function() {
      var $gallery = $(this).flickity({
        pageDots: true, 
        wrapAround: false,
        cellAlign: 'left',
        lazyLoad: true,
        draggable: true,
        freeScroll: false,
        prevNextButtons: false,
      });

      // Flickity instance
      var flkty = $gallery.data('flickity');
      // elements
      var $cellButtonGroup = $('.button-group--cells');
      var $cellButtons = $cellButtonGroup.find('.button');
      var $galleryNav = $('.button-group');
      var $galleryNavItems = $galleryNav.find('li');

      // previous
      var $previousButton = $('.button--previous').on( 'click', function() {
        $gallery.flickity('previous');
      });
      // next
      var $nextButton = $('.button--next').on( 'click', function() {
        $gallery.flickity('next');
      });

      // update selected cellButtons
      $gallery.on( 'select.flickity', function() {
        $galleryNav.find('.is-selected').removeClass('is-selected');
        $galleryNavItems.eq( flkty.selectedIndex ).addClass('is-selected');
        $gallery.on( 'select.flickity', function() {
          $galleryNav.find('.is-selected').removeClass('is-selected');
          $galleryNavItems.eq( flkty.selectedIndex ).addClass('is-selected');
        });
      });

      $gallery.on( 'cellSelect', function() {
        $cellButtons.filter('.is-selected')
          .removeClass('is-selected');
        $cellButtons.eq( flkty.selectedIndex )
          .addClass('is-selected');
      });

      // select cell on button click
      $cellButtonGroup.on( 'click', '.button', function() {
        var index = $(this).index();
        $gallery.flickity( 'select', index );
      });
    });

    $('.carousel').each(function() {
      var $carousel = $(this).flickity({
        wrapAround: true,
        fade: true,
        pageDots: true,
        prevNextButtons: false,
        draggable: true,
      });
    
      // elements
      var $cellButtonGroup = $('.carousel-button-group--cells');
      var $cellButtons = $cellButtonGroup.find('.carousel-button');
      var $galleryNav = $('.carousel-button-group');
      var $galleryNavItems = $galleryNav.find('li');
    
      // previous
      var $previousButton = $('.carousel-button--previous').on( 'click', function() {
        $carousel.flickity('previous');
      });
      // next
      var $nextButton = $('.carousel-button--next').on( 'click', function() {
        $carousel.flickity('next');
      });
    
      var $carouselNav = $('.carousel-nav');
      var $carouselNavCells = $carouselNav.find('.carousel-cell');
    
      $carouselNav.on( 'click', '.carousel-cell', function( event ) {
        var index = $( event.currentTarget ).index();
        $carousel.flickity( 'select', index );
      });
    
      var flkty = $carousel.data('flickity');
      var navTop  = $carouselNav.position().top;
      var navCellHeight = $carouselNavCells.height();
      var navHeight = $carouselNav.height();
    
      $carousel.on( 'select.flickity', function() {
        // set selected nav cell
        $galleryNav.find('.is-selected').removeClass('is-selected');
        $galleryNavItems.eq( flkty.selectedIndex ).addClass('is-selected');
        $carousel.on( 'select.flickity', function() {
          $galleryNav.find('.is-selected').removeClass('is-selected');
          $galleryNavItems.eq( flkty.selectedIndex ).addClass('is-selected');
        });
        $carouselNav.find('.is-nav-selected').removeClass('is-nav-selected');
        var $selected = $carouselNavCells.eq( flkty.selectedIndex )
          .addClass('is-nav-selected');
        // scroll nav
        var scrollY = $selected.position().top + $carouselNav.scrollTop() - ( navHeight + navCellHeight ) / 2 + (navCellHeight);
        // console.log(scrollY);
        $carouselNav.animate({
          scrollTop: scrollY
        });
      });
    
      $carousel.on( 'cellSelect', function() {
        $cellButtons.filter('.is-selected')
          .removeClass('is-selected');
        $cellButtons.eq( flkty.selectedIndex )
          .addClass('is-selected');
      });
    
      // select cell on button click
      $cellButtonGroup.on( 'click', '.carousel-button', function() {
        var index = $(this).index();
        $carousel.flickity( 'select', index );
      });
    });
  },
  finalize() {
    // SCROLL BAR
    jQuery(document).ready(function() {
      var winHeight = jQuery(window).height(),
          docHeight = jQuery(document).height(),
          progressBar = jQuery('progress'),
          max,
          value;

      /* Set the max scrollable area */
      max = docHeight - winHeight;
      progressBar.attr('max', max);

      jQuery(document).on('scroll', function(){
       value = jQuery(window).scrollTop();
       progressBar.attr('value', value);
      });
    });

    $('.textfill').textfill({
      minFontPixels: 14,
      maxFontPixels: 800,
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js